
import React from 'react';
import './ImpPage.css'



const ImpPage = () => {
    return <div className='ImpPage'>
        <div className='ImpPageWrapper'>
            <div class="entry-content">
                <h1>Impressum</h1>
                <h2>Angaben gemäß § 5 TMG</h2>
                <p>Katja Bär-Hanuja</p>
                <p>Ernährungsberatung Katja Bär-Hanuja</p>
                <p>Derlerstraße 184</p>
                <p>66346 Püttlingen</p>
                <h2>Kontakt</h2>
                <p>Telefon: 06898/63374</p>
                <p>E-Mail: k.baer-hanuja@gmx.de</p>
                <h2>Umsatzsteuer-ID</h2>
                <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</p>
                <p>040/227/20134</p>
                <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
                <p>Berufsbezeichnung: Dipl. Ing. für Ernährungs- und Haushaltstechnik</p>
                <p>Verliehen durch: Deutschland</p>
                <h2>Streitschlichtung</h2>
                <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.<br />
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                <p>Quelle: <a href="https://www.e-recht24.de/impressum-generator.html">https://www.e-recht24.de/impressum-generator.html</a></p>
                <p>&nbsp;</p>
            </div>

        </div>

    </div>
}

export default ImpPage;